import styled from 'styled-components'

export const Title = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  padding-bottom: 2rem;

  @media screen and (min-width: 768px) {
    padding-bottom: 4rem;
  }
`
